// extracted by mini-css-extract-plugin
export default {"sortableThElem":"ThElem_sortableThElem__wHJih","thElem":"ThElem_thElem__wuh-K","asc":"ThElem_asc__wZ5M5","desc":"ThElem_desc__1FPjp"};